module.exports = __webpack_public_path__ + "static/img/chuchai.bde33739.png";